<template>
  <div class="country-container" @click.prevent="isListActive = !isListActive">
    <div class="flag-holder" ref="city">
      <div class="flag-text-holder" v-if="selectedCity">
        {{ selectedCity }}
      </div>
      <div class="flag-text-holder text-gray-400" v-else>
        Sélectionnez une ville
      </div>
    </div>
    <button type="button">
      <i class="fa-solid fa-chevron-down"></i>
    </button>
    <div class="dropdown-content" :class="{ flagList: isListActive }">
      <input
        type="text"
        v-model="searchQuery"
        placeholder="Rechercher une ville..."
        class="country-search-input"
        @input="filterCities"
        @click.stop
      />
      <div class="no-result" v-if="filteredCities.length <= 0">
        Aucun résultat
      </div>
      <ul :class="{ flagList: isListActive }">
        <li
          v-for="(city, index) in filteredCities"
          :key="index"
          @click="changeCity(city)"
        >
          <span>{{ city }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "CityDropdown",
  props: {
    cities: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue", "change"],
  data() {
    return {
      isListActive: false,
      searchQuery: "",
      filteredCities: [],
      selectedCity: "",
    };
  },
  watch: {
    cities: {
      immediate: true,
      handler(newCities) {
        this.filteredCities = newCities.map((c) =>
          typeof c === "object" ? c.name : c,
        );
        if (
          this.selectedCity &&
          !this.filteredCities.includes(this.selectedCity)
        ) {
          this.selectedCity = "";
          this.$emit("update:modelValue", "");
        }
      },
    },
    modelValue: {
      immediate: true,
      handler(newVal) {
        this.selectedCity = newVal;
      },
    },
  },
  methods: {
    changeCity(city) {
      this.selectedCity = city;
      this.$emit("update:modelValue", city);
      this.$emit("change", city);
      this.isListActive = false;
      this.searchQuery = "";
      this.filteredCities = this.cities.map((c) =>
        typeof c === "object" ? c.name : c,
      );
    },
    filterCities() {
      const query = this.searchQuery.toLowerCase().trim();
      const allCitiesNames = this.cities.map((c) =>
        typeof c === "object" ? c.name : c,
      );
      this.filteredCities = allCitiesNames.filter((city) =>
        city.toLowerCase().includes(query),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../../assets/scss/index.scss";
@use "../../../assets/scss/variables.scss" as *;
@use "../../../assets/scss/mixins.scss" as *;

.country-container {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  width: 100%;
  justify-content: space-between;

  &:hover {
    background-color: $back-color;
  }
  .flag-holder {
    width: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    padding-right: 10px;
  }
  .flag-text-holder {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    background: transparent;
    & svg {
      @include svg-icon($size: 20px);
    }
  }
  .country-search-input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-top: none;
    border-bottom: 1px solid #ddd;
    outline: none;
  }
  .dropdown-content {
    position: absolute;
    bottom: 100%;
    margin-bottom: 5px;
    min-width: 100%;
    width: 100%;
    background-color: $white-color;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    min-height: auto;
    max-height: 250px;
    left: 0;
    border-radius: 5px;
    overflow: hidden;
    z-index: 50;
  }
  .no-result {
    width: 100%;
    text-align: center;
    padding: 10px;
  }
  ul {
    display: block;
    max-height: 200px;
    width: 100%;
    padding: 10px 0;
    background-color: $white-color;
    overflow-y: auto;
    flex-direction: column;
    scroll-behavior: smooth;
    scrollbar-color: $accent-color;
    scrollbar-width: thin;
    border-radius: 5px;

    &::-webkit-scrollbar {
      width: 5px;
      height: 20px;
    }
    &::-webkit-scrollbar-track {
      margin: 15px 0;
      box-shadow: inset 0 0 5px #f5f6f7;
      border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb {
      background: $accent-color;
      border-radius: $f-radius-6;
    }
    li {
      display: flex;
      padding: 0.5rem;
      align-items: center;
      cursor: pointer;
      & > span {
        margin-left: 15px;
      }
      &:hover {
        background-color: $back-color;
      }
    }
  }
  .flagList {
    display: none;
  }
}
</style>
